import React from 'react'

interface ChatEmptyStateProps {
  onStartNewChat: () => void
}

const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({ onStartNewChat }) => {
  return (
    <div className="h-full flex flex-col items-center justify-center bg-app-white-100">
      <div className="max-w-md text-center">
        {/* Chat Icon */}
        <div className="w-24 h-24 bg-app-primary-10 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-12 h-12 text-app-primary-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-3.582 8-8 8a8.955 8.955 0 01-2.485-.349c-.834.198-1.696.299-2.595.299-3.314 0-6-2.686-6-6 0-3.314 2.686-6 6-6h.007c.552-2.72 2.914-4.783 5.722-4.783C17.97 3.167 21 6.197 21 10c0 .69-.117 1.356-.333 1.977z"
            />
          </svg>
        </div>

        {/* Welcome Message */}
        <h2 className="text-2xl font-semibold text-app-black-100 mb-2">Start a conversation and connect with your team!</h2>
        <p className="text-app-grey-60 mb-8">
          Select a conversation from the sidebar or start a new chat to begin messaging.
        </p>

        {/* Call to Action Button */}
        <button
          onClick={onStartNewChat}
          className="inline-flex items-center gap-2 bg-app-primary-60 text-app-white-100 px-6 py-3 rounded-lg font-medium hover:bg-app-primary-70 transition-colors duration-150"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
          Start a New Chat
        </button>
      </div>
    </div>
  )
}

export default ChatEmptyState 